// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_dBq","label":"styles_label__219eL"};